import { dateFormat } from "nq-js";
import { categories, descriptions, ratingCategories } from "./staticVariables";
import InterviewTable from "./InterviewTable";
import { useEffect, useState } from "react";
import InterviewTally from "./InterviewTally";
import InterviewImpression from "./InterviewImpression";

function InterviewFormPDF({ object }) {
  const [interviewObject, setInterview] = useState({});

  useEffect(() => {
    setInterview({ ...object });

    console.warn("interviewForm", object);
  }, [object]);

  const employeeFullName = `${object?.firstName || ""} ${
    object?.middleName || ""
  } ${object?.lastName || ""}`;

  const getRatingCategoryForPoints = (points) => {
    if (points === 0) return null;

    return ratingCategories.find(
      (category) => points >= category.range[0] && points <= category.range[1]
    );
  };

  const getTotalPoints = () => {
    const interviewForm = interviewObject?.interviewForm;

    const appearanceRating = Number(interviewForm?.appearanceRating) || 0;
    const bearingRating = Number(interviewForm?.bearingRating) || 0;
    const expressionRating = Number(interviewForm?.expressionRating) || 0;
    const jobKnowledgeRating = Number(interviewForm?.jobKnowledgeRating) || 0;
    const motivationRating = Number(interviewForm?.motivationRating) || 0;
    const personalityRating = Number(interviewForm?.personalityRating) || 0;

    // const {
    //   appearanceRating,
    //   bearingRating,
    //   expressionRating,
    //   jobKnowledgeRating,
    //   motivationRating,
    //   personalityRating,
    // } = interviewForm;

    console.warn("interviewfORM", appearanceRating);

    return (
      Number(appearanceRating) +
      Number(bearingRating) +
      Number(expressionRating) +
      Number(jobKnowledgeRating) +
      Number(motivationRating) +
      Number(personalityRating)
    );
  };
  const totalPoints = getTotalPoints();
  const currentRatingCategory = getRatingCategoryForPoints(totalPoints);

  const styles = {
    content: { fontSize: "1.3rem" },
    header: { fontSize: "1.5rem" },
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          padding: "1.5rem 2rem",
          margin: "0 3rem",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: "2rem",
          }}
        >
          <img
            src="/lgstop.png"
            alt="LGS Logo"
            className="logo"
            width={180}
            style={{
              alignSelf: "center",
              marginBottom: "1rem",
            }}
          />

          <p
            style={{
              textAlign: "center",
              margin: "0",
              fontSize: styles.header.fontSize,
            }}
          >
            Office Address: P.E.S. Bldg. 1639 Dian St., San Isidro, Makati City
            Philippines
          </p>
          <p style={{ textAlign: "center", fontSize: styles.header.fontSize }}>
            Telephone Number: (632) 8889-2680
          </p>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h2 style={{ textAlign: "center" }}>INTERVIEW FORM</h2>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignContent: "center" }}>
              <b style={{ fontSize: styles.content.fontSize }}>Name:</b>
              <p
                style={{
                  borderBottom: "1px solid black",
                  padding: "0 1rem",
                  margin: 0,
                  fontSize: styles.content.fontSize,
                }}
              >
                {employeeFullName}
              </p>
            </div>

            <div style={{ display: "flex", alignContent: "center" }}>
              <b style={{ fontSize: styles.content.fontSize }}>Date:</b>
              <p
                style={{
                  borderBottom: "1px solid black",
                  padding: "0 1rem",
                  margin: 0,
                  fontSize: styles.content.fontSize,
                }}
              >
                {dateFormat(object?.created) || ""}
              </p>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "0.5rem",
              marginBottom: "1.5rem",
            }}
          >
            <div
              style={{
                display: "flex",
                alignContent: "center",
              }}
            >
              <b style={{ fontSize: styles.content.fontSize }}>
                Position Applied:
              </b>
              <p
                style={{
                  borderBottom: "1px solid black",
                  padding: "0 1rem",
                  margin: 0,
                  fontSize: styles.content.fontSize,
                }}
              >
                {`${object?.positionApplied || ""}`}
              </p>
            </div>
          </div>

          <InterviewTable
            object={interviewObject}
            categories={categories}
            descriptions={descriptions}
            styles={styles}
          />

          <InterviewTally
            categories={categories}
            formState={interviewObject?.interviewForm}
            calculateTotalPoints={totalPoints}
            styles={styles}
          />

          <InterviewImpression
            ratingCategories={ratingCategories}
            currentRatingCategory={currentRatingCategory}
            styles={styles}
          />

          <div
            style={{
              display: "flex",
              marginTop: "1.5rem",
              gap: "1rem",
            }}
          >
            <div
              style={{
                flex: "0 0 50%",
                maxWidth: "50%",
                padding: "0 8px",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                border: "1px solid #ddd",
                borderRadius: "5px",
                padding: "8px",
                backgroundColor: "#f8f9fa",
              }}
            >
              <label
                style={{ fontWeight: "600", fontSize: styles.content.fontSize }}
              >
                Comments:
              </label>
              <div style={{ padding: "0.8rem" }}>
                <u
                  style={{
                    width: "100%",
                    fontSize: styles.content.fontSize,
                  }}
                >
                  {interviewObject?.interviewForm?.comments}
                </u>
              </div>
            </div>

            <div
              style={{
                flex: "0 0 50%",
                maxWidth: "50%",
                padding: "0 8px",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                border: "1px solid #ddd",
                borderRadius: "5px",
                padding: "8px",
                backgroundColor: "#f8f9fa",
              }}
            >
              <label
                style={{ fontWeight: "600", fontSize: styles.content.fontSize }}
              >
                Recommendation:
              </label>
              <div style={{ padding: "0.8rem" }}>
                <u
                  style={{
                    width: "100%",
                    fontSize: styles.content.fontSize,
                  }}
                >
                  {interviewObject?.interviewForm?.recommendation}
                </u>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InterviewFormPDF;
